<template>
  <div id="Header">
    <header>
      <div class="header-box">
        <ul class="head">
          <li id="logo">
            <img class="img" src="~@/assets/img/Slice 19.png" @click="ToHomepage" alt="" />
          </li>
        </ul>

        <div class="right-box">

          <div class="name">
            <span style="color:#F3A000">{{ userInfo.userName }}</span>
          </div>
          <!--          <el-tooltip class="item" effect="dark" :content="userInfo.userName" placement="bottom">-->
          <!--            <div class="name">-->
          <!--&lt;!&ndash;              您好！用户&ndash;&gt;-->
          <!--&lt;!&ndash;              <span style="color:#F3A000">{{ userInfo.userName }}</span>&ndash;&gt;-->
          <!--            </div>-->
          <!-- </el-tooltip> -->
          <el-dropdown>
            <div class="block">
              <el-avatar
                  :size="48"
                  :src="defaultUrl ? defaultUrl : require(`@/assets/img/headerImg.png`)"
              ></el-avatar>
              <!--              <el-avatar :size="54" :src="require(`@/assets/img/headerImg.png`)"></el-avatar>-->
            </div>
            <el-dropdown-menu slot="dropdown" style="width: 139px;padding: 10px 0px 0px">
              <!--              <div-->
              <!--                style="text-align: center; border-bottom: 1px solid #EBEBEB;cursor: default;background-color: #fff"-->
              <!--              >-->
              <!--                <el-avatar-->
              <!--                  :size="54"-->
              <!--                  :src="defaultUrl ? defaultUrl : require(`@/assets/img/headerImg.png`)"-->
              <!--                ></el-avatar>-->
              <!--                &lt;!&ndash;                <el-avatar v-else :src="userInfo.url" :size="54" />&ndash;&gt;-->
              <!--                &lt;!&ndash;                <el-avatar :size="40" :src="require(`@/assets/img/headerImg.png`)"></el-avatar>&ndash;&gt;-->
              <!--                <div style="color:#000;font-size: 18px; padding-bottom: 20px; padding-top: 4px">-->
              <!--                  {{ userInfo.userName }}-->
              <!--                </div>-->
              <!--              </div>-->
              <!-- style=" display:flex; justify-content: space-between; border-bottom: 1px solid #EBEBEB"             <el-dropdown-item>-->
              <ol>
                <li class="li-text" @click="handleChack">
                  <div style="display: flex;padding: 10px 24px">
                    <div style="padding-right: 11px;">
                      <img src="@/assets/img/Slice 34.png" alt="img" />
                    </div>
                    {{ $t('view_profile') }}
                  </div>
                </li>
                <li class="li-text" @click="handleEdit">
                  <div style="display: flex;padding: 10px 24px">
                    <div style="padding-right: 11px;">
                      <img src="@/assets/img/Slice 33.png" alt="img" />
                    </div>
                    {{ $t('edit_profile') }}
                  </div>
                </li>
                <li class="li-text" @click="handleEditPassword">
                  <div style="display: flex;padding: 10px 24px;margin-bottom: 10px">
                    <div style="padding-right: 11px;">
                      <img src="@/assets/img/Slice 35.png" alt="img" />
                    </div>
                    {{ $t('edit_password') }}
                  </div>
                </li>
              </ol>
              <div style="border-top: 1px solid #EBEBEB;margin: 10px 24px"></div>
              <ol>
                <li class="li-text" @click="hamdleInfo">
                  <div style="display: flex;padding: 10px 24px">
                    <div style="padding-right: 11px;">
                      <img src="@/assets/img/Slice 36.png" alt="img" />
                    </div>
                    {{ $t('info_center') }}
                  </div>
                </li>
                <li class="li-text" @click="exit">
                  <div style="display: flex;padding: 10px 24px; margin-bottom: 10px">
                    <div style="padding-right: 11px;">
                      <img src="@/assets/img/Slice 37.png" alt="img" />
                    </div>
                    {{ $t('log_out') }}
                  </div>
                </li>
              </ol>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <!--  查看用户资料弹窗  -->
      <el-dialog
          :title="dialog.title[dialog.status]"
          :visible.sync="dialog.chack"
          :modal-append-to-body="false"
          :append-to-body="false"
          :close-on-click-modal="false"
          width="500px"
          style="margin-top: 15vh"
      >
        <div style="display: flex; align-items: center; margin-bottom: 17px;">
          <div style="padding-right: 30px;padding-left: 5px">
            <el-avatar
                :size="70"
                :src="defaultUrl ? defaultUrl : require(`@/assets/img/headerImg.png`)"
            ></el-avatar>
            <!--            <el-avatar v-else :src="userInfo.url" :size="100" />-->
          </div>
          <div>
            <div class="padding">{{ $t('account_nickname') }}：<span>{{ userInfo.userName }}</span></div>
            <div class="padding">{{ $t('contact_phone') }}：<span>{{ userInfo.phone }}</span></div>
            <div class="padding">{{ $t('contact_email') }}：<span>{{ userInfo.email }}</span></div>
            <div class="padding">{{ $t('company_name') }}：<span>{{ userInfo.teamName }}</span></div>
          </div>
        </div>
      </el-dialog>
      <!--   编辑用户资料   -->
      <el-dialog
          :title="dialog.title[dialog.status]"
          :visible.sync="dialog.edit"
          :modal-append-to-body="false"
          :append-to-body="false"
          :close-on-click-modal="false"
          width="600px"
          style="margin-top: 15vh"
      >
        <el-form
            label-position="left"
            ref="change"
            :model="change"
            :rules="rules"
            label-width="100px"
            class="form1"
        >
          <div style="display: flex; align-items: center">
            <div style="padding-right: 30px">
              <el-form-item label-width="0">
                <div class="headImg">
                  <el-avatar
                      v-if="userInfo.url === ''"
                      :size="70"
                      :src="require(`@/assets/img/headerImg.png`)"
                  ></el-avatar>
                  <el-avatar v-else class="avatar" :src="userInfo.url" :size="70" />
                  <el-upload
                      class="upload-demo"
                      ref="upload"
                      :http-request="uploadFile"
                      action="#"
                      :on-change="handleChange"
                      :show-file-list="false"
                      :file-list="fileList"
                      accept=".jpg,.jpeg"
                  >
                    <!--        :auto-upload="false"            -->
                    <el-button class="buttonUp" type="text" size="small" :loading="loading">
                      {{ $t('upload_avatar') }}
                    </el-button>
                  </el-upload>
                </div>
              </el-form-item>
            </div>

            <div style="width: 450px;">
              <el-form-item :label="$t('Nickname') + ':'" prop="name">
                <el-input
                    v-model.trim="change.name"
                    maxlength="30"
                    :placeholder="$t('enter_account_nickname')"
                    show-word-limit
                    clearable
                />
              </el-form-item>

              <!--              <el-form-item label="联系电话:" prop="phone">
              <el-input
                  v-model.trim="change.phone"
                  maxlength="11"
                  placeholder="请输入联系电话"
                 show-word-limit
                 clearable
               />
             </el-form-item>

             <el-form-item label="验证码:" prop="code">
              <el-input v-model.trim="change.code" maxlength="6" placeholder="请输入验证码" />
               <div class="captcha-btn">
                  <el-button v-show="AuthCode2" type="text" @click="getNewCode">
                   获取验证码
                 </el-button>
                 <el-button v-show="!AuthCode2" type="text">
                   {{ auth_time2 }}秒后重新发送
                  </el-button>
                </div>
             </el-form-item>-->

              <el-form-item :label="$t('email') + ':'" prop="email">
                <el-input
                    v-model.trim="change.email"
                    maxlength="30"
                    :placeholder="$t('enter_email')"
                    show-word-limit
                    clearable
                />
              </el-form-item>
            </div>
          </div>
        </el-form>
        <el-button :loading="loading" class="button" @click="handleEditInfoConfirm">{{ $t('confirm') }}</el-button>
      </el-dialog>
      <!--   编辑密码    -->
      <el-dialog
          :title="dialog.title[dialog.status]"
          :visible.sync="dialog.password"
          :modal-append-to-body="false"
          :append-to-body="false"
          :close-on-click-modal="false"
          width="500px"
          style="margin-top: 15vh"
      >
        <el-form
            ref="param"
            :model="param"
            label-position="left"
            label-width="150px"
            :rules="rules"
            class="form1"
        >
          <el-form-item :label="$t('original_password') + '：'" prop="password">
            <el-input
                v-model.trim="param.password"
                type="password"
                clearable
                :placeholder="$t('enter_password')"
                show-password
                :max="16"
            />
          </el-form-item>

          <el-form-item :label="$t('new_password') + '：'" prop="newPassword1">
            <el-input
                v-model.trim="param.newPassword1"
                :placeholder="$t('enter_new_password')"
                clearable
                show-password
                :max="16"
            />
          </el-form-item>

          <el-form-item :label="$t('confirm_password') + '：'" prop="newPassword2">
            <el-input
                v-model.trim="param.newPassword2"
                :placeholder="$t('again_enter_password')"
                clearable
                show-password
                :max="16"
            />
          </el-form-item>
          <el-button :loading="loading" class="button" @click="handleEditPasswordConfirm">
            {{ $t('confirm') }}
          </el-button>
        </el-form>
      </el-dialog>
      <!--   系统消息   -->
      <el-dialog
          :title="dialog.title[dialog.status]"
          :visible.sync="dialog.info"
          :modal-append-to-body="false"
          :append-to-body="false"
          :close-on-click-modal="false"
          width="800px"
      >
        <div style="text-align: center; color: #231815; height: 377px;display: flex; justify-content: center; align-items: center;" v-if="this.infoData.length === 0">
          {{ $t('noData') }}
        </div>
        <ul v-else class="info-box" style="height: 377px;">
          <!--列表项-->
          <li
              v-for="(item, index) in infoData"
              :key="index"
              class="content"
              :class="item.hasRead === 1 ? 'active' : ''"
          >
            <!--消息内容-->
            <el-tooltip :content="item.message">
              <div class="text">{{ item.message }}</div>
            </el-tooltip>

            <!--日期-->
            <div class="date">{{ item.date }}</div>
          </li>
        </ul>
        <span slot="footer" class="dialog-footer" style="padding-bottom: 25px"></span>
      </el-dialog>
    </header>
  </div>
</template>

<script>
import API from '@/api';
import cookies from '@/utils/cookies';
import { store } from '@/store/index.js';
// import {request} from "@/api/request";
// import * as promise from "autoprefixer";
export default {
  name: 'HeaderName',
  data() {
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('please_enter_password')));
      } else if (value !== this.param.newPassword1) {
        callback(new Error(this.$t('twice_password')))
      } else {
        callback();
      }
    };
    return {
      defaultUrl: '',
      data: '', // 个人资料
      fileList: [], // 上传的文件列表
      listdata: new FormData(),
      phone: '',
      // NewParam: {
      //   phone: '',
      //   code: '' //新手机号验证码
      // },
      AuthCode2: true, // 新手机号控制显示
      auth_time2: 60, // 新手机号倒计时
      // oldCode: {
      //   code: '' //原手机号验证码
      // },
      loading: false, // 加载
      dialog: {
        chack: false,
        edit: false,
        password: false,
        info: false,
        title: {
          chack: this.$t('view_user_profile'),
          edit: this.$t('edit_user_profile'),
          password: this.$t('edit_password'),
          info: this.$t('system_messages'),
        },
        status: '',
      },
      // 密码
      param: {
        password: '',
        newPassword1: '',
        newPassword2: '',
      },
      change: {
        name: '',
        email: '',
        phone: '',
        code: '', // 新手机号验证码
      },
      infoData: [],
      info: {
        count: 10,
        page: 0,
        total: 0,
        type: '',
      },
      userInfo: {
        userName: '',
        url: '',
        phone: '',
        email: '',
        teamName: '',
      },
      VUE_APP_USERCONSOLE: process.env.VUE_APP_USERCONSOLE,
      VUE_APP_HOME: process.env.VUE_APP_HOME,
      VUE_APP_LOGIN: process.env.VUE_APP_LOGIN,
      router: '',
      rules: {
        name: [{ required: true, trigger: 'change', message: this.$t('enter_account_nickname') }],
        code: [
          { required: true, trigger: 'change', message: this.$t('verification_code') },
          {
            pattern: /^\d{6}$/,
            message: this.$t('correct_verification_code_format'),
            trigger: 'blur',
          },
        ],
        email: [
          { required: true, trigger: 'change', message: this.$t('enter_email') },
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: this.$t('login_invalid_email'),
            trigger: 'blur',
          },
        ],
        password: [
          { required: true, message: this.$t('please_enter_old_password'), trigger: 'blur' },
          {
            pattern: /^[\w!@#$%^&*]{6,16}$/,
            message: this.$t('characters'),
            trigger: 'blur',
          },
        ],
        newPassword1: [
          { required: true, message: this.$t('enter_new_password'), trigger: 'blur' },
          {
            pattern: /^[\w!@#$%^&*]{6,16}$/,
            message: this.$t('characters'),
            trigger: 'blur',
          },
        ],
        newPassword2: [
          { required: true, message: this.$t('again_enter_password'), trigger: 'blur' },
          { validator: validatePass2, trigger: 'change' },
        ],
        phone: [
          { required: true, message: this.$t('please_enter_phone_number'), trigger: 'blur' },
          { pattern: /^1[3-9][0-9]{9}$/, message: this.$t('please_enter_valid_phone_number'), trigger: 'blur' },
        ],
      },
    };
  },

  computed: {
    // 上传的地址
    Url() {
      return `${process.env.VUE_APP_API}/psl/user/url/modify`;
    },
  },
  created() {
    this.getUserInfo();
    this.getmessage();
  },
  methods: {
    MenuAct() {
      this.$store.dispatch('reSetMenu', '/PrintSteward/PrintHome');
      this.$store.dispatch('reSetMenuArr', ['/PrintSteward/PrintHome']);
    },
    CourseMenuAct() {
      this.$store.dispatch('reSetCourseMenu', '/Course/Selection');
    },
    // 上传图片前
    uploadFile(file) {
      this.listdata.append('file', file.file);
    },
    // 上传头像
    handleChange(file) {
      const isType = file.name.split('.');
      const pdf = isType[isType.length - 1] === 'jpg';
      const jpeg = isType[isType.length - 1] === 'jpeg';
      const isLt1G = file.size / 1024 / 1024 < 50;
      if (!pdf && !jpeg) {
        this.$message.error(this.$t('uploaded_image'));
        this.fileList = [];
        return;
      }
      if (!isLt1G) {
        this.$message.error(this.$t('uploaded_file_size_exceed'));
        this.fileList = [];
        return;
      }

      const tempUrl = window.URL.createObjectURL(file.raw);
      this.userInfo.url = tempUrl;
    },

    // 获取消息列表
    getmessage() {
      API.message(this.info)
          .then((res) => {
            this.info.total = res.message.data.totalCount;
            this.infoData = res.message.data.list;
          })
          .catch((mgs) => {
            console.log(mgs);
          });
    },
    handleCurrentChange(page) {
      this.info.page = page - 1;
      this.getmessage();
    },
    // 返回portal首页
    ToHomepage() {
      window.open(`${this.VUE_APP_HOME}`);
    },
    // 查看用户资料
    handleChack() {
      this.dialog.status = 'chack';
      this.dialog.chack = true;
    },
    // 新手机号格式
    checkNewPhone() {
      const reg = /^1[3|4|5|7|8][0-9]{9}$/;
      const res = reg.test(this.change.phone);
      return res;
    },
    // 获取新手机号验证码
    getNewCode() {
      if (this.change.phone.length <= 0) {
        this.$message({
          message: this.$t('mobile_number_cannot_empty'),
          type: 'warning',
          duration: 1000,
        });
      } else if (!this.checkNewPhone()) {
        this.$message({
          message: this.$t('please_enter_valid_phone_number'),
          type: 'warning',
          duration: 1000,
        });
      } else {
        API.getNewPhone({ phone: this.change.phone })
            .then((res) => {
              if (res.message.success === true) {
                this.$message({
                  message: res.message.message,
                  type: 'success',
                  duration: 1000,
                });
                this.AuthCode2 = false;
                this.auth_time2 = 60;
                const authTimeTimer2 = setInterval(() => {
                  this.auth_time2 -= 1;
                  if (this.auth_time2 <= 0) {
                    this.AuthCode2 = true;
                    clearInterval(authTimeTimer2);
                  }
                }, 1000);
              } else {
                this.$message({
                  message: res.message.message,
                  type: 'warning',
                  duration: 1000,
                });
              }
            })
            .catch((mgs) => {
              console.log(mgs);
            });
      }
    },
    // 编辑用户资料
    handleEdit() {
      this.dialog.status = 'edit';
      this.dialog.edit = true;
      this.change.name = this.userInfo.userName;
      // this.change.phone = this.userInfo.phone
      this.userInfo.url = this.defaultUrl;
      this.change.email = this.userInfo.email;
      this.$nextTick(() => {
        // 清除验证
        this.$refs.change.clearValidate();
      });
    },
    // 编辑用户资料确定
    handleEditInfoConfirm() {
      this.listdata = new FormData();
      this.$refs.upload.submit();
      this.$refs.change.validate((valid) => {
        if (valid) {
          this.listdata.append('email', this.change.email);
          this.listdata.append('name', this.change.name);
          this.listdata.append('file', this.userInfo.url);
          this.loading = true;
          API.name(this.listdata)
              .then((res) => {
                if (res.message.success === true) {
                  this.$message({
                    message: res.message.message,
                    type: 'success',
                    duration: 1000,
                  });
                  this.dialog.edit = false;
                  this.loading = false;
                  this.getUserInfo();
                } else {
                  this.$message({
                    message: res.message.message,
                    type: 'warning',
                    duration: 1000,
                  });
                }
              })
              .catch((mgs) => {
                // this.loading = false
                console.log(mgs);
              })
              .finally(() => {
                // this.loading = false
              });
        }
      });
    },

    // 编辑密码
    handleEditPassword() {
      this.param = {
        password: '',
        newPassword1: '',
        newPassword2: '',
      };
      this.dialog.status = 'password';
      this.dialog.password = true;
      this.$nextTick(() => {
        // 清除验证
        this.$refs.param.clearValidate();
      });
    },
    // 编辑密码确定
    handleEditPasswordConfirm() {
      this.$refs.param.validate((valid) => {
        if (valid) {
          this.loading = true;
          if (cookies.get('token')) {
            API.repassword(this.param)
                .then((res) => {
                  if (res.message.success === true) {
                    this.$message({
                      message: this.$t('password_edited_success'),
                      type: 'success',
                      duration: 1000,
                    });
                    this.dialog.password = false;
                    this.loading = false;
                    this.param = {
                      password: '',
                      newPassword1: '',
                      newPassword2: '',
                    };
                  } else {
                    this.loading = false;
                    this.$message({
                      message: res.message.message,
                      type: 'error',
                      duration: 1000,
                    });
                  }
                })
                .catch((mgs) => {
                  this.loading = false;
                  console.log(mgs);
                })
                .finally(() => {
                  this.loading = false;
                });
          } else {
            window.open(`${process.env.VUE_APP_PAY}login/:SUP/`, '_self');
          }
        }
      });
    },
    // 消息中心
    hamdleInfo() {
      this.dialog.status = 'info';
      this.dialog.info = true;
    },
    // 退出登录
    exit() {
      this.$confirm(this.$t('log_out_user'), this.$t('prompt'), {
        closeOnClickModal: false,
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
          .then(() => {
            store.dispatch('logout').then(() => {
              localStorage.setItem('deviceId', '')
              cookies.remove('token');
              window.open(`${this.VUE_APP_HOME}`, '_self');
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('cancelled'),
            });
          });
    },
    // 获取个人信息
    getUserInfo() {
      store.dispatch('getInfo').then((res) => {
        if (res.message.success) {
          this.userInfo = res.message.data;
          this.defaultUrl = res.message.data.url;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  .el-dialog__header {
    background-color: #fff;
    font-size: 16px;
  }
  ::v-deep .el-dialog__title{
    font-size: 16px;
  }
  ::v-deep .el-dialog__body{
    padding: 0px 20px;
  }
  //.el-dialog__body{
  //  border-bottom: 1px solid;
  //}
  .info-box {
    //margin: 20px 0;
    //padding-bottom: 25px;
    //border-top: 1px solid;
    // 内容
    .content {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      /*line-height: 64px;*/
      white-space: nowrap;
      padding: 15px 5px;
      background: #fff;
      list-style: none;
      cursor: s-resize;
      &:before {
        font-size: 4px;
        padding-right: 10px;
      }
      &:nth-child(even) {
        background: #fff;
      }
      &:hover {
        color: rgb(37, 23, 23);
      }
      &.active {
        color: rgb(38, 27, 31);
        border-bottom: 1px solid rgb(192, 190, 191);
      }
      // 文本
      .text {
        flex: 1 1 auto;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #231815;
      }
      // 日期
      .date {
        flex: 0 0 200px;
        text-align: right;
      }
    }
  }
  .button {
    //width: 100%;
    background-color: rgb(235, 155, 2);
    color: #fff;
    margin: 0px 5px 20px;
    padding: 8px 34px;
    float: right;
  }
  .padding {
    padding: 9px 0;
    color: #231815;
    span{
      padding-left: 19px;
      font-size: 14px;
    }
  }
  background: #ffffff;
  font-size: 14px;
  .header-box {
    margin: auto;
    height: 70px;
    background: #fff;
    box-shadow: 0px 2px 6px 3px #bcbcbc;
    .right-box {
      float: right;
      margin-right: 40px;
      height: 100%;
      padding-top: 8px;
      display: flex;
      align-items: center;
      display: flex;
    }
    #logo {
      height: 70px;
      width: 114px;
      margin-left: 50px;
      text-align: center;
      .img {
        margin-top: 14px;
        height: 45px;
        width: 114px;
      }
    }
    .head li {
      width: 80px;
      height: 70px;
      line-height: 70px;
      float: left;
      margin-right: 80px;
      cursor: pointer;
      .exit {
        width: 120px;
        height: 57px;
        line-height: 57px;
      }
    }
    .exit:hover {
      color: #f3a000;
    }
    .head > li a:hover {
      color: #f3a000;
    }
    .UserName {
      width: 200px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      float: right;
      cursor: pointer;
      color: #231815;
      position: relative;
    }
    .UserName:hover .menu {
      display: block;
      transition: all ease 0.3s;
    }
    .information {
      width: 120px;
      height: 60px;
      text-align: center;
      line-height: 60px;
      float: right;
      cursor: pointer;
      color: #231815;
    }
    .menu {
      display: none;
      position: absolute;
      top: 60px;
      right: 0px;
      border: 1px solid #9999;
      background: #ffffff;
      z-index: 9;
      .pullDown {
        width: 70px;
        height: 60px;
        line-height: 60px;
        text-decoration: none;
        display: block;
      }
      li {
        width: 70px;
        height: 60px;
        color: #231815;
      }
    }
    .pullDown:hover {
      color: #f3a000;
      transition: all ease 0.3s;
    }
    .menu > li:hover a {
      color: #f3a000;
      transition: all ease 0.3s;
    }
  }
}
.pullDown {
  color: #231815;
}
.pullDown {
  width: 120px;
  height: 60px;
  line-height: 60px;
  text-decoration: none;
  display: block;
}
.Name {
  color: #f3a000;
  font-size: 20px;
  margin: 0px 10px;
}
.FristPage {
  width: 80px;
  height: 70px;
  line-height: 70px;
  display: block;
  color: #231815;
  font-weight: bold;
  font-size: 20px;
  color: #ffffff;
  text-decoration: none;
}
.head {
  .active {
    color: #f3a000;
    text-decoration: none;
    transition: all ease 0.3s;
  }
}
.active {
  color: #f3a000;
  /*border-bottom: 10px solid #F3A000;*/
  text-decoration: none;
  transition: all ease 0.3s;
  &:after {
    display: block;
    width: 100%;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }
}
.active1 {
  color: #f3a000;
  text-decoration: none;
  transition: all ease 0.3s;
}
.right {
  display: flex;
  margin-right: 20px;
  .IMG {
    width: 36px;
    height: 36px;
  }
}
.name {
  color: #f3a000;
  height: 70px;
  line-height: 70px;
  text-align: center;
  font-weight: 700;
  margin-right: 15px;
}
.block {
  //height: 40px;
  //line-height: 40px;
  //margin-top: 10px;
}
// 获取验证码按钮
.captcha-btn {
  position: absolute;
  top: 0;
  right: 10px;
}
// 上传头像
.headImg {
  display: flex;
  align-items: center;

  // 文本
  .avatar-text {
    width: 80px;
  }
  // 上传按钮
  .upload-demo {
    height: 70px;
    width: 70px;
    margin-left: -70px;
    border: 0;
    color: #fff;
    &:hover {
      border-radius: 50%;
      opacity: 1;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  .buttonUp {
    opacity: 0;
    padding: 29px 10px;
    border: 0;
    &:hover {
      color: #fff;
      border-radius: 50%;
      opacity: 1;
    }
  }
}
.form1 {
  padding: 10px 5px 0px;
}
.li-text {
  text-align: center;
  //padding: 20px 0px;
  color: #231815;
  cursor: pointer;
  font-size: 14px;
}
.li-text div {
  cursor: pointer;
}
.li {
  font-size: 14px;
}
.li-font {
  padding: 20px 0px;
  cursor: pointer;
  color: #000;
}
</style>
